import { CommonModule } from '@angular/common';
import {
  BannerModule,
  BreadcrumbsModule,
  CardModule,
  ChipsModule,
  DialogModule,
  DividerModule,
  DocumentPreviewModule,
  DropdownModule,
  DynamicTableModule,
  FlyoutMenuModule,
  FlyoutMenuV2Module,
  IconModule,
  ImageModule,
  LinkModule,
  MediaCardModule,
  NotificationsModule,
  ProgressBarModule,
  RadioModule,
  ScrollModule,
  SearchModule,
  SectionTitleModule,
  SideBarModule,
  SignInModule,
  StickyFooterModule,
  TabsModule,
  TextInputModule,
  ThumbnailModule,
  TitleModule,
} from '@frk/eds-components';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@shared/translate/translate.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LiteratureDialogModule } from './literature-dialog/literature-dialog.module';
import * as FtSignIn from './../shared/sign-in/sign-in.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrSdkModule } from '@bloomreach/ng-sdk';

export const LITERATURE_MODULE_IMPORTS = [
  CommonModule,
  DropdownModule,
  SearchModule,
  ChipsModule,
  IconModule,
  ImageModule,
  LinkModule,
  SideBarModule,
  ReactiveFormsModule,
  RouterModule,
  SharedModule,
  BannerModule,
  BrSdkModule,
  StickyFooterModule,
  DialogModule,
  BreadcrumbsModule,
  TitleModule,
  DividerModule,
  DynamicTableModule,
  ThumbnailModule,
  FlyoutMenuModule,
  FlyoutMenuV2Module,
  FtSignIn.SignInModule,
  // LiteratureHeaderModule,
  MediaCardModule,
  NgxSkeletonLoaderModule,
  TabsModule,
  RadioModule,
  ProgressBarModule,
  TextInputModule,
  TranslateModule,
  SignInModule,
  DocumentPreviewModule,
  SectionTitleModule,
  CardModule,
  NotificationsModule,
  ScrollModule,
  LiteratureDialogModule,
];
